import CompanyWhiteLabelDialogContainer from './company-white-label-dialog.container';

export default CompanyWhiteLabelDialogContainer;
